import { useEffect, useRef, useState } from "react";
import AdminTopNavBar from "../common/AdminTopNavBar";
import getUserMenuItems from "./AdminMenuContent";
import AdminSideBar from "./AdminSideBar";
import { adminReqConfig, api } from "../../include/api";
import { useNavigate } from "react-router-dom";
import AdminFooter from "../common/AdminFooter";
import "../../styles/CategoryProductList.css";
import { useNotification } from "../../Toast/ToastProvider";
import { ChevronDown, Eye, EyeOff, X } from "react-feather";
import { ERROR, SUCCESS } from "../../include/constant";
import Papa from "papaparse";
import { RotateCcwKey } from "lucide-react";
import { getAdmin } from "../../include/function";
const ListUser = () => {
  const navigate = useNavigate();
  const homeLink = "/admin";
  const [fetchLoading, setFetchLoading] = useState(true);
  const [userList, setUserList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [isSidebarMinimized, setIsSidebarMinimized] = useState(false);
  const toggleSidebar = () => setIsSidebarMinimized(!isSidebarMinimized);
  const menuContent = getUserMenuItems();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [roleMap, setRoleMap] = useState({});
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [resetModal, setResetModal] = useState({
    isOpen: false,
    userId: null,
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    showCurrent: false,
    showNew: false,
    showConfirm: false,
  });
  const [filterValues, setFilterValues] = useState({
    roles: "",
    user: "",
  });
  const user = getAdmin();
  const [productPermissions, setProductPermissions] = useState({
    add: false,
    view: false,
    edit: false,
    delete: false,
  });

  const [appliedFilters, setAppliedFilters] = useState({
    roles: "",
    user: "",
  });

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!user?.roleId) return;

      try {
        const res = await api.get(
          `/role_permission/?roleId=${user.roleId}`,
          adminReqConfig(),
        );
        if (res.status === 200 && Array.isArray(res.data.data)) {
          // Find permission entry where pageTitle === "Product"
          const productPerm = res.data.data.find(
            (p) => p.pageTitle === "Users",
          );

          if (productPerm) {
            setProductPermissions({
              add: productPerm.add === "true" || productPerm.add === 1,
              view: productPerm.view === "true" || productPerm.view === 1,
              edit: productPerm.edit === "true" || productPerm.edit === 1,
              delete: productPerm.delete === "true" || productPerm.delete === 1,
            });
          }
        }
      } catch (err) {
        console.warn("Failed to fetch product permissions", err);
      }
    };

    fetchPermissions();
  }, [user?.roleId]);
  const toast = useNotification();

  // ✅ Single reliable data fetch
  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        const [roleRes, userRes] = await Promise.all([
          api.get("/role/", adminReqConfig()),
          api.get("/user/", adminReqConfig()),
        ]);
        const roles = roleRes.data.data || [];
        const users = userRes.data.data || [];

        // Build role map
        const map = {};
        roles.forEach((role) => {
          map[role.id] = role.name || role.roleName || "Unknown Role";
        });

        const enriched = users
          .filter((user) => user.id !== -1)
          .map((user) => ({
            ...user,
            roleName: map[user.roleId] || "—",
          }));

        if (isMounted) {
          setRoleMap(map);
          setUserList(enriched);
          setFilteredData(enriched);
        }
      } catch (error) {
        console.error("Fetch error:", error);
        if (isMounted) {
          setUserList([]);
          setFilteredData([]);
          toast({ type: ERROR, message: "Failed to load users or roles." });
        }
      } finally {
        if (isMounted) setFetchLoading(false);
      }
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  // Pagination logic
  let currentItems = [];
  let totalPage = 1;
  let showingFrom = 0;
  let showingTo = 0;

  if (itemsPerPage === "all") {
    currentItems = filteredData;
    showingFrom = filteredData.length > 0 ? 1 : 0;
    showingTo = filteredData.length;
  } else {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    totalPage = Math.ceil(filteredData.length / itemsPerPage);
    showingFrom = indexOfFirstItem + 1;
    showingTo = Math.min(indexOfLastItem, filteredData.length);
  }

  // const applyFilters = () => {
  //   let result = [...userList];

  //   if (filterValues.roles) {
  //     result = result.filter(
  //       (user) => String(user.roleId) === String(filterValues.roles),
  //     );
  //   }

  //   if (filterValues.user) {
  //     result = result.filter(
  //       (user) => String(user.id) === String(filterValues.user),
  //     );
  //   }

  //   setFilteredData(result);
  //   setCurrentPage(1);
  //   setIsFilterPanelOpen(false);
  // };

  const applyFilters = () => {
    setAppliedFilters({ ...filterValues });
    setCurrentPage(1);
    setIsFilterPanelOpen(false);
  };

  // useEffect(() => {
  //   if (!searchQuery.trim()) {
  //     setFilteredData(userList);
  //     return;
  //   }
  //   if (searchQuery.trim()) {
  //     const query = searchQuery.trim().toLowerCase();
  //     const result = filteredData.filter(
  //       (user) =>
  //         (user.name && user.name.toLowerCase().startsWith(query)) ||
  //         (user.emailId && user.emailId.toLowerCase().startsWith(query)) ||
  //         (user.userId && user.userId.toLowerCase().startsWith(query)) ||
  //         (user.roleName && user.roleName.toLowerCase().startsWith(query)),
  //     );
  //     setFilteredData(result);
  //     setCurrentPage(1);
  //   }
  // }, [searchQuery, filteredData]);

  // ✅ DELETE the old search useEffect completely and replace with this:
  useEffect(() => {
    let result = [...userList];

    // 1. Apply role filter
    if (appliedFilters.roles) {
      result = result.filter(
        (user) => String(user.roleId) === String(appliedFilters.roles),
      );
    }

    // 2. Apply user filter
    if (appliedFilters.user) {
      result = result.filter(
        (user) => String(user.id) === String(appliedFilters.user),
      );
    }

    // 3. Apply search query
    if (searchQuery.trim()) {
      const query = searchQuery.trim().toLowerCase();
      result = result.filter(
        (user) =>
          (user.name && user.name.toLowerCase().startsWith(query)) ||
          (user.emailId && user.emailId.toLowerCase().startsWith(query)) ||
          (user.userId && user.userId.toLowerCase().startsWith(query)) ||
          (user.roleName && user.roleName.toLowerCase().startsWith(query)),
      );
    }

    setFilteredData(result);
    setCurrentPage(1);
  }, [searchQuery, appliedFilters, userList]); // ✅ Clean dependencies

  const clearFilters = () => {
    setFilterValues({ roles: "", user: "" });
    setAppliedFilters({ roles: "", user: "" });
    setSearchQuery("");
    setFilteredData(userList);
    setCurrentPage(1);
    setIsFilterPanelOpen(false);
  };

  // Actions
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleView = (userId) => {
    navigate(`/admin/user/userAddNew?id=${userId}&view=true`);
  };

  const handleEdit = (userId) => {
    navigate(`/admin/user/userAddNew?id=${userId}`);
  };

  const handleDelete = (userId) => {
    if (!userId) {
      toast({ type: ERROR, message: "Invalid user ID" });
      return;
    }

    if (window.confirm("Are you sure you want to delete this user?")) {
      setFetchLoading(true);
      api
        .delete(`/user/?id=${userId}`, adminReqConfig())
        .then((response) => {
          const message = response.data?.message || "User deleted successfully";
          toast({ type: SUCCESS, message });
          const updatedList = userList.filter(
            (user) => String(user.id) !== String(userId),
          );
          setUserList(updatedList);
          setFilteredData(updatedList);
          setSelectedData((prev) =>
            prev.filter((id) => String(id) !== String(userId)),
          );
        })
        .catch((error) => {
          console.error("Delete error:", error);
          const msg =
            error.response?.data?.message ||
            error.message ||
            "Failed to delete user. Please try again.";
          toast({ type: ERROR, message: msg });
        })
        .finally(() => {
          setFetchLoading(false);
        });
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedData(currentItems.map((p) => p.id));
    } else {
      setSelectedData((prev) =>
        prev.filter((id) => !currentItems.map((p) => p.id).includes(id)),
      );
    }
  };

  const handleSelectOne = (id) => {
    setSelectedData((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id],
    );
  };
  const handleDownloadCSV = (exportScope = "current") => {
    let dataToExport = [];

    // ✅ PRIORITY 1: If items selected → ALWAYS export selected (overrides everything)
    if (selectedData.length > 0) {
      dataToExport = userList.filter((p) => selectedData.includes(p.id));
    }
    // ✅ PRIORITY 2: If "Export All" clicked → export entire dataset
    else if (exportScope === "all") {
      dataToExport = userList;
    }
    // ✅ PRIORITY 3: Default → export current page items only
    else {
      dataToExport = currentItems;
    }

    if (dataToExport.length === 0) {
      toast({ type: "error", message: "No User data to download" });
      return;
    }

    const productColumns = [
      "S.No",
      "User ID",
      "User Name",
      "Mail Id",
      "Phone",
      "Roles",
      "Status",
    ];

    const csvData = dataToExport.map((p, i) => ({
      "S.No": i + 1,
      "User ID": p.userId,
      "User Name": p.name,
      "Mail Id": p.emailId,
      Phone: p.phoneNumber,
      Roles: p.roleName || "-",
      Status: p.status || "-",
    }));

    // ✅ CRITICAL FIX: The word "data" followed by colon, then the mapping
    const csv = Papa.unparse({
      fields: productColumns,
      data: csvData.map(function (row) {
        return productColumns.map(function (col) {
          return row[col];
        });
      }),
    });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // ✅ Dynamic filename based on export type
    const fileName =
      selectedData.length > 0
        ? `User_Selected_${selectedData.length}.csv`
        : exportScope === "all"
          ? "User_All.csv"
          : `User_Page${currentPage}.csv`;

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleStatusChange = (userId, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    const payload = { status: newStatus };
    api
      .put(`/user/?id=${userId}&flag=changeStatus`, payload, adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          toast({ type: SUCCESS, message: `User ${newStatus} successfully!` });
          setUserList((prev) =>
            prev.map((p) =>
              p.id === userId ? { ...p, status: newStatus } : p,
            ),
          );
          setFilteredData((prev) =>
            prev.map((p) =>
              p.id === userId ? { ...p, status: newStatus } : p,
            ),
          );
        }
      })
      .catch((error) => {
        console.error("Status update failed:", error);
        toast({ type: ERROR, message: "Failed to update user status." });
      });
  };

  const filterWrapperRef = useRef(null);

  // Close filter panel on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isFilterPanelOpen &&
        filterWrapperRef.current &&
        !filterWrapperRef.current.contains(event.target)
      ) {
        setIsFilterPanelOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isFilterPanelOpen]);
  const submitPasswordChange = () => {
    const { userId, currentPassword, newPassword, confirmPassword } =
      resetModal;

    if (!userId || !currentPassword || !newPassword) {
      toast({ type: ERROR, message: "All fields are required." });
      return;
    }

    if (newPassword !== confirmPassword) {
      toast({ type: ERROR, message: "New passwords do not match." });
      return;
    }

    setFetchLoading(true);
    api
      .put(
        `/user/?id=${encodeURIComponent(userId)}&flag=changepassword`,
        {
          currentPassword: currentPassword.trim(),
          newPassword: newPassword.trim(),
        },
        adminReqConfig(),
      )
      .then((response) => {
        toast({
          type: SUCCESS,
          message: response.data?.message || "Password changed successfully!",
        });
        setResetModal((prev) => ({ ...prev, isOpen: false }));
      })
      .catch((error) => {
        console.error("Password change error:", error);
        const msg =
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to change password. Please try again.";
        toast({ type: ERROR, message: msg });
      })
      .finally(() => {
        setFetchLoading(false);
      });
  };
  const handleResetPasswordClick = (userId) => {
    setResetModal({
      isOpen: true,
      userId,
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      showCurrent: false,
      showNew: false,
      showConfirm: false,
    });
  };

  return (
    <>
      <AdminSideBar
        menuContent={menuContent}
        isMinimized={isSidebarMinimized}
      />
      <AdminTopNavBar
        toggleSidebar={toggleSidebar}
        isSidebarMinimized={isSidebarMinimized}
        homeLink={homeLink}
        title="USERS LIST"
      />
      <div
        className="content-wrapper p-0"
        style={{ marginLeft: isSidebarMinimized ? "80px" : "250px", flex: "1" }}
      >
        <section
          style={{
            backgroundColor: "#F1F4F9",
            padding: "30px",
            marginTop: "70px",
            marginBottom: "40px",
          }}
        >
          {fetchLoading ? (
            <p>Loading User...</p>
          ) : (
            <>
              <div
                className="ps-22 pe-22 pb-22 rounded-5"
                style={{ backgroundColor: "#fff" }}
              >
                <div className="row align-items-center px-24 py-10 mb-3">
                  {/* 1. Header */}
                  <div className="col-auto">
                    <h6 className="mb-0">All Users List</h6>
                  </div>

                  {/* 2. Search + Filter */}
                  <div className="col d-flex align-items-center">
                    <div
                      className="filter-wrapper"
                      style={{
                        position: "relative",
                        width: "100%",
                        maxWidth: "500px",
                      }}
                      ref={filterWrapperRef}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #c6d6f5",
                          borderRadius: "8px",
                          backgroundColor: "#fff",
                          width: "100%",
                        }}
                      >
                        <img
                          src="/assets/images/search-icon.png"
                          style={{ width: "18px", marginLeft: "8px" }}
                        />
                        <input
                          type="text"
                          placeholder="Filter and search here..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          onFocus={() => setIsFilterPanelOpen(true)}
                          style={{
                            border: "none",
                            outline: "none",
                            padding: "8px 8px",
                            width: "100%",
                            fontSize: "14px",
                            color: "#333",
                            backgroundColor: "transparent",
                          }}
                        />
                        {searchQuery && (
                          <X
                            size={24}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSearchQuery("");
                              setCurrentPage(1);
                              setIsFilterPanelOpen(false);
                            }}
                            style={{
                              position: "absolute",
                              right: "40px",
                              cursor: "pointer",
                              color: "#999",
                              padding: "4px",
                              zIndex: 10,
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.color = "#666")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.color = "#999")
                            }
                          />
                        )}
                        <ChevronDown
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#999",
                            cursor: "pointer",
                            transform: isFilterPanelOpen
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.2s",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsFilterPanelOpen(!isFilterPanelOpen);
                          }}
                        />
                      </div>

                      {isFilterPanelOpen && (
                        <FilterPanel
                          filterValues={filterValues}
                          onFilterChange={(key, value) =>
                            setFilterValues((prev) => ({
                              ...prev,
                              [key]: value,
                            }))
                          }
                          onApply={applyFilters}
                          onClear={clearFilters}
                          roleMap={roleMap}
                          userList={userList}
                        />
                      )}
                    </div>
                  </div>

                  {/* 3. Add New + 4. Options – right-aligned */}
                  <div className="col-auto d-flex align-items-center gap-2">
                    {/* ✅ Add New Button - styled like ListProduct */}
                    {productPermissions.add && (
                      <button
                        className="btn me-0 mb-0"
                        style={{
                          height: "40px",
                          width: "140px",
                          color: "white",
                          backgroundColor: "#2696D5",
                          border: "none",
                          borderRadius: "6px",
                        }}
                        onClick={() => navigate("/admin/user/userAddNew")}
                      >
                        Add New
                      </button>
                    )}

                    {/* ✅ Dropdown */}
                    <CustomDropdown handleDownloadCSV={handleDownloadCSV} />
                  </div>
                </div>

                <div className="table-responsive mt-24 product-table">
                  <table className="table table-striped custom-striped-table-product-list align-middle">
                    <thead>
                      <tr>
                        <th style={{ width: "50px" }}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ borderColor: "#c5d5f5" }}
                            onChange={handleSelectAll}
                            checked={
                              currentItems.length > 0 &&
                              currentItems.every((p) =>
                                selectedData.includes(p.id),
                              )
                            }
                          />
                        </th>
                        <th
                          style={{
                            width: "20%",
                            textWrap: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          S.No
                        </th>
                        <th
                          style={{
                            width: "20%",
                            textWrap: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          User ID
                        </th>
                        <th
                          style={{
                            width: "20%",
                            textWrap: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          User Name
                        </th>
                        <th
                          style={{
                            width: "20%",
                            textWrap: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          Mail ID
                        </th>
                        <th
                          style={{
                            width: "20%",
                            textWrap: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          Phone
                        </th>
                        <th
                          style={{
                            width: "20%",
                            textWrap: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          Roles
                        </th>
                        <th
                          style={{
                            width: "20%",
                            textWrap: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          Status
                        </th>
                        <th
                          style={{
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((user, index) => (
                          <tr key={user.id}>
                            <td>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                style={{ borderColor: "#c5d5f5" }}
                                checked={selectedData.includes(user.id)}
                                onChange={() => handleSelectOne(user.id)}
                              />
                            </td>
                            <td
                              style={{
                                width: "20%",
                                textWrap: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              {index + 1}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                textWrap: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              {user.userId}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                textWrap: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              {user.name}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                textWrap: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              {user.emailId}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                textWrap: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              {user.phoneNumber}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                textWrap: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              {user.roleName}
                            </td>
                            <td>
                              <div className="form-check form-switch">
                                <input
                                  className={`form-check-input form-product-status-switch ${
                                    user.status === "active"
                                      ? "switch-green"
                                      : "switch-orange"
                                  }`}
                                  type="checkbox"
                                  id={`statusSwitch-${user.id}`}
                                  checked={user.status === "active"}
                                  onChange={() =>
                                    handleStatusChange(user.id, user.status)
                                  }
                                />
                              </div>
                            </td>
                            <td
                              style={{
                                width: "20%",
                                textWrap: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              <div className="d-flex gap-1">
                                {productPermissions.view && (
                                  <button
                                    style={{
                                      backgroundColor: "#d9ebff",
                                      height: "39px",
                                      width: "50px",
                                      border: "none",
                                      borderRadius: "4px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleView(user.id)}
                                  >
                                    <img
                                      src="/assets/images/view-icon.png"
                                      alt="View"
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        objectFit: "contain",
                                      }}
                                    />
                                  </button>
                                )}
                                {productPermissions.edit && (
                                  <button
                                    style={{
                                      backgroundColor: "#d9ebff",
                                      height: "39px",
                                      width: "50px",
                                      border: "none",
                                      borderRadius: "4px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleEdit(user.id)}
                                  >
                                    <img
                                      src="/assets/images/edit-icon.png"
                                      alt="Edit"
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        objectFit: "contain",
                                      }}
                                    />
                                  </button>
                                )}
                                {productPermissions.delete && (
                                  <button
                                    style={{
                                      backgroundColor: "#d9ebff",
                                      height: "39px",
                                      width: "50px",
                                      border: "none",
                                      borderRadius: "4px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleDelete(user.id)}
                                  >
                                    <img
                                      src="/assets/images/delete-icon.png"
                                      alt="Delete"
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        objectFit: "contain",
                                      }}
                                    />
                                  </button>
                                )}
                                <button
                                  style={{
                                    backgroundColor: "#d9ebff",
                                    height: "39px",
                                    width: "50px",
                                    border: "none",
                                    borderRadius: "4px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleResetPasswordClick(user.id);
                                  }}
                                  title="Change Password"
                                >
                                  <RotateCcwKey
                                    color="#2D96D3"
                                    strokeWidth={1.3}
                                  />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            No Users found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-16 p-16">
                  <div className="d-flex align-items-center">
                    <select
                      className="form-select d-inline-block w-auto"
                      value={itemsPerPage}
                      onChange={(e) => {
                        const val = e.target.value;
                        setItemsPerPage(val === "all" ? "all" : parseInt(val));
                        setCurrentPage(1);
                      }}
                      style={{
                        height: "34px",
                        fontSize: "14px",
                        minWidth: "70px",
                      }}
                    >
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="all">All</option>
                    </select>
                    <span className="ms-2">
                      Showing {showingFrom} to {showingTo} of{" "}
                      {filteredData.length} Users
                    </span>
                  </div>
                  <nav>
                    <ul className="pagination mt-0">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          &laquo;
                        </button>
                      </li>
                      {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(
                          1,
                          currentPage - Math.floor(pagesToShow / 2),
                        );
                        let endPage = startPage + pagesToShow - 1;
                        if (endPage > totalPage) {
                          endPage = totalPage;
                          startPage = Math.max(1, endPage - pagesToShow + 1);
                        }
                        return Array.from(
                          { length: endPage - startPage + 1 },
                          (_, i) => startPage + i,
                        ).map((pageNum) => (
                          <li
                            key={pageNum}
                            className={`page-item ${
                              currentPage === pageNum ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => paginate(pageNum)}
                            >
                              {pageNum}
                            </button>
                          </li>
                        ));
                      })()}
                      <li
                        className={`page-item ${
                          currentPage === totalPage ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          &raquo;
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </>
          )}
          <AdminFooter isSidebarMinimized={isSidebarMinimized} />
        </section>
      </div>
      {/* Reset Password Modal */}
      {resetModal.isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
            padding: "20px",
          }}
          onClick={() => setResetModal((prev) => ({ ...prev, isOpen: false }))}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              width: "100%",
              maxWidth: "450px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
              padding: "24px",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h6 className="mb-0 fs-5">Change Password</h6>
            <button
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                width: "32px",
                height: "32px",
                background: "none",
                border: "3px solid #ddd",
                borderRadius: "50%",
                fontSize: "24px",
                cursor: "pointer",
                color: "#6E7C94",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
              }}
              onClick={() =>
                setResetModal((prev) => ({ ...prev, isOpen: false }))
              }
            >
              &times;
            </button>
            <hr />
            {/* Current Password */}
            <div className="mb-3" style={{ position: "relative" }}>
              <label
                className="form-label"
                style={{
                  fontSize: "0.9rem",
                  fontWeight: 500,
                  color: "#555",
                  marginBottom: "6px",
                }}
              >
                Current Password
              </label>
              <input
                type={resetModal.showCurrent ? "text" : "password"}
                className="form-control"
                value={resetModal.currentPassword}
                onChange={(e) =>
                  setResetModal((prev) => ({
                    ...prev,
                    currentPassword: e.target.value,
                  }))
                }
                style={{
                  width: "100%",
                  padding: "8px 40px 8px 12px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "0.95rem",
                  transition: "border-color 0.2s",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#2b95d3")}
                onBlur={(e) => (e.target.style.borderColor = "#ddd")}
              />
              <span
                onClick={() =>
                  setResetModal((prev) => ({
                    ...prev,
                    showCurrent: !prev.showCurrent,
                  }))
                }
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "70%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#777",
                }}
              >
                {resetModal.showCurrent ? (
                  <Eye size={16} />
                ) : (
                  <EyeOff size={16} />
                )}
              </span>
            </div>

            {/* New Password */}
            <div className="mb-3" style={{ position: "relative" }}>
              <label
                className="form-label"
                style={{
                  fontSize: "0.9rem",
                  fontWeight: 500,
                  color: "#555",
                  marginBottom: "6px",
                }}
              >
                New Password
              </label>
              <input
                type={resetModal.showNew ? "text" : "password"}
                className="form-control"
                value={resetModal.newPassword}
                onChange={(e) =>
                  setResetModal((prev) => ({
                    ...prev,
                    newPassword: e.target.value,
                  }))
                }
                style={{
                  width: "100%",
                  padding: "8px 40px 8px 12px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "0.95rem",
                  transition: "border-color 0.2s",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#2b95d3")}
                onBlur={(e) => (e.target.style.borderColor = "#ddd")}
              />
              <span
                onClick={() =>
                  setResetModal((prev) => ({ ...prev, showNew: !prev.showNew }))
                }
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "70%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#777",
                }}
              >
                {resetModal.showNew ? <Eye size={16} /> : <EyeOff size={16} />}
              </span>
            </div>

            {/* Confirm Password */}
            <div className="mb-12" style={{ position: "relative" }}>
              <label
                className="form-label"
                style={{
                  fontSize: "0.9rem",
                  fontWeight: 500,
                  color: "#555",
                  marginBottom: "6px",
                }}
              >
                Confirm New Password
              </label>
              <input
                type={resetModal.showConfirm ? "text" : "password"}
                className="form-control"
                value={resetModal.confirmPassword}
                onChange={(e) =>
                  setResetModal((prev) => ({
                    ...prev,
                    confirmPassword: e.target.value,
                  }))
                }
                style={{
                  width: "100%",
                  padding: "8px 40px 8px 12px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "0.95rem",
                  transition: "border-color 0.2s",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#2b95d3")}
                onBlur={(e) => (e.target.style.borderColor = "#ddd")}
              />
              <span
                onClick={() =>
                  setResetModal((prev) => ({
                    ...prev,
                    showConfirm: !prev.showConfirm,
                  }))
                }
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "70%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#777",
                }}
              >
                {resetModal.showConfirm ? (
                  <Eye size={16} />
                ) : (
                  <EyeOff size={16} />
                )}
              </span>
            </div>

            {/* Error if passwords don't match */}
            {resetModal.newPassword !== resetModal.confirmPassword &&
              resetModal.confirmPassword && (
                <p
                  style={{
                    color: "#e74c3c",
                    fontSize: "0.85rem",
                    marginBottom: "16px",
                    textAlign: "center",
                  }}
                >
                  New passwords do not match.
                </p>
              )}

            <div className="d-flex justify-content-end gap-2">
              <button
                type="button"
                style={{
                  backgroundColor: "#bed9f8ff",
                  color: "#2B95D3",
                  border: "none",
                  padding: "8px 12px",
                  fontWeight: "500",
                  borderRadius: "5px",
                  fontSize: "14px",
                  minWidth: "80px",
                  textAlign: "center",
                }}
                onClick={() => {
                  setResetModal((prev) => ({ ...prev, isOpen: false }));
                  navigate("/admin/user/userList");
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                disabled={
                  !resetModal.currentPassword ||
                  !resetModal.newPassword ||
                  resetModal.newPassword !== resetModal.confirmPassword
                }
                onClick={submitPasswordChange}
                style={{
                  backgroundColor: "#2B95D3",
                  color: "#fff",
                  border: "none",
                  padding: "8px 12px",
                  fontWeight: "500",
                  borderRadius: "5px",
                  fontSize: "14px",
                  minWidth: "80px",
                  textAlign: "center",
                }}
                onMouseOver={(e) => {
                  if (
                    resetModal.currentPassword &&
                    resetModal.newPassword &&
                    resetModal.newPassword === resetModal.confirmPassword
                  ) {
                    e.target.style.backgroundColor = "#1a7bb9";
                  }
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#2b95d3";
                }}
              >
                Update Password
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};;

export default ListUser;

const CustomDropdown = ({ handleDownloadCSV }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Options");
  const dropdownRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  const options = [
    { label: "Export", value: "export" },
    { label: "Export All", value: "exportAll" },
  ];

 const handleSelect = (opt) => {
  setSelected(opt.label);
  setIsOpen(false);
  
  if (opt.value === "export") {
    // ✅ Export = current page only (but selected overrides)
    handleDownloadCSV("current");
  } else if (opt.value === "exportAll") {
    // ✅ Export All = entire dataset (but selected overrides)
    handleDownloadCSV("all");
  }
  
  setSelected("Options");
};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div
      className="custom-select"
      style={{ position: "relative", display: "inline-block" }}
      ref={dropdownRef}
    >
      <div
        className="select-header"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          backgroundColor: isHovered ? "#EDF8FA" : "#fff",
          color: "rgba(129, 134, 134, 1)",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          width: "140px",
          height: "40px",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 500,
          transition: "background-color 0.2s ease",
        }}
      >
        <span>{selected}</span>
        <ChevronDown />
      </div>
      {isOpen && (
        <ul
          className="select-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            backgroundColor: "white",
            border: "none",
            borderRadius: "4px",
            zIndex: 1000,
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: 500,
          }}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              onClick={() => handleSelect(opt)}
              className="select-option"
              style={{
                padding: "8px 12px",
                color: "rgba(129, 134, 134, 1)",
                backgroundColor: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const FilterPanel = ({
  filterValues,
  onFilterChange,
  onApply,
  onClear,
  roleMap,
  userList,
}) => {
  const rolesArray = Object.entries(roleMap).map(([id, name]) => ({
    id,
    roleName: name,
  }));

  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "500px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        zIndex: 1000,
        padding: "16px",
        maxHeight: "500px",
        overflowY: "auto",
        marginTop: "10px",
      }}
    >
      <div className="row g-3">
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.roles}
            onChange={(e) => onFilterChange("roles", e.target.value)}
          >
            <option value="">All Roles</option>
            {rolesArray.map((role) => (
              <option key={role.id} value={role.id}>
                {role.roleName}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.user}
            onChange={(e) => onFilterChange("user", e.target.value)}
          >
            <option value="">All Users</option>
            {userList.map((u) => (
              <option key={u.id} value={u.id}>
                {u.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="d-flex gap-14 mt-24">
        <button
          onClick={onApply}
          style={{
            color: "#fff",
            backgroundColor: "#2b95d3",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
          }}
        >
          Apply Filters
        </button>
        <button
          onClick={onClear}
          style={{
            color: "#2692d2",
            backgroundColor: "#d9ebff",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
          }}
        >
          Clear All
        </button>
      </div>
    </div>
  );
};
